module.exports = "<div class=\"videoplayerContainer\">\n  <videogular vg-theme=\"vm.config.theme\"\n              vg-native-fullscreen=\"false\"\n              vg-error=\"vm.onError($event)\"\n              vg-player-ready=\"vm.onPlayerReady($API)\">\n    <vg-media vg-src=\"vm.config.sources\">\n    </vg-media>\n    <vg-buffering></vg-buffering>\n  </videogular>\n</div>\n<button ng-click=\"vm.onSelect()\"\n        ng-keydown=\"vm.remoteKeydown($event)\"\n        class=\"focusable\">\n  <span>Enlarge</span>\n  <div class=\"enlargeIcons\">\n    <div class=\"bottomIcon\"></div>\n    <div class=\"topIcon\"></div>\n  </div>\n</button>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/liveFeedVideo/liveFeedVideo.html
 ** module id = 123
 ** module chunks = 0
 **/